const en = {
	tipsTitle:
		'Note: the following is the source information of the label, which is for reference only',
	projectManager: 'project manager',
	labelOwner: 'label owner',
};

export default en;
